import { useEffect } from "react";
import { useParams } from "react-router-dom";

export const DeepLink = () => {
  const { path } = useParams();

  const deepLink = "mm3d://";

  useEffect(() => {
    if (typeof window !== "undefined") {
      console.log(`${deepLink}${path}`);
      window.location.href = `${deepLink}${path}`;
    }
  }, [path]);
  return <></>;
};
